module.exports = __webpack_public_path__ + "static/media/serv-3.0dee7543.jpg";